import React, { useMemo } from 'react';
import './style.scss';
import SVGLogo from '../../../assets/images/logo';
import clsx from 'clsx';

export interface CirclesBackgroundProps {
  scale?: number;
  scaleShift?: number;
  colors?: [string, string, string];
  backgroundColor?: string;
  top?: string | number;
  left?: string | number;
  size?: string | number;
  enableLogo?: boolean;
  zIndex?: number;
}

const CirclesBackground = ({
  scale = 1,
  scaleShift = 0.2,
  colors = ['#482893', '#402285', '#3C217A'],
  backgroundColor = '#351D6F',
  top = '50vh',
  left = '50vw',
  size = '100px',
  enableLogo = false,
  zIndex
}: CirclesBackgroundProps) => {
  const wrapperStyle = useMemo(
    () => ({
      top: `calc(${top} - ${size}/2 )`,
      left: `calc(${left} - ${size}/2)`,
      backgroundColor,
      zIndex
    }),
    [backgroundColor, top, left, size, zIndex]
  );

  const circleStyles = useMemo(() => {
    return [...Array(3)].map((_, index) => ({
      width: size,
      height: size,
      background: colors[index],
      transform: `scale(${scale * (1 + index * scaleShift)})`
    }));
  }, [size, colors, scaleShift, scale]);

  const logoWrapperStyle = useMemo(
    () => ({
      width: size,
      height: size,
      transform: `scale(${scale * 0.7}) translate(4%, 4%)`
    }),
    [size, scale]
  );

  const logoStyle = useMemo(() => {
    return {
      width: size,
      height: size
    };
  }, [size]);

  return (
    <div className='circles-background' style={wrapperStyle}>
      <div style={circleStyles[0]} />
      <div style={circleStyles[1]} />
      <div style={circleStyles[2]} />
      <div
        className={clsx(
          'circles-background-logo-wrapper',
          enableLogo && 'cb-lw-enabled'
        )}
        style={logoWrapperStyle}
      >
        <SVGLogo color='#321E68' style={logoStyle} />
      </div>
    </div>
  );
};

export default CirclesBackground;
